export default __webpack_public_path__ + "static/media/browse-hunting-site-1.f1c28e08.jpg";